<div class="background"><app-website-header></app-website-header>
    <div class="containerr" >
        <div style=" width: 100%; padding: 0 20px 0 100px; background: #E1F1FF;">
            <div
            class="welcome p-0 g-0 py-2 py-md-5 row d-flex flex-column flex-xl-row align-items-lg-center justify-content-xl-between" >
            <div class="img col-12 col-xl-4 order-2 order-xl-1" style="max-width: 700px;">
                <img [src]="carouselImgs[currCarousel] ||'../../../../assets/images/EmptyLabImage.svg'" alt="" class="d-flex d-lg-none img-fluid"
                    style="height: 320px !important; border-radius: 20px;">
                <img [src]="carouselImgs[currCarousel] ||'../../../../assets/images/EmptyLabImage.svg'" alt="" class="d-none d-lg-block col-12" height="700px"
                    style="border-radius: 20px;">
                <div class="points">
                    <div class="pointE" (click)="carouselChange(point)"
                        *ngFor="let point of carouselImgs.slice(0, currCarousel)"></div>
                    <div class="point"></div>
                    <div class="pointE" (click)="carouselChange(point)"
                        *ngFor="let point of carouselImgs.slice(currCarousel+1)"></div>
                </div>
            </div>
            <div class="top-intro col-12 col-xl-6 w-100 w-xl-25 order-1 order-xl-2" style="flex: 1;">
                <p class="welcomee libra lh-sm">WELCOME TO</p>
                <p class="hospitalName d-md-none name2 libra fs-2 lh-sm"> {{ labData?.organization }} </p>
                <p class="hospitalName d-none d-md-block name2 libra"> {{ labData?.organization }} </p>
            </div>
        </div>
        </div>

        <div class="contact-section" style="background: linear-gradient(to bottom,#E1F1FF 50%, white 50%);">
            <div class="contact">
                <div class="inner">

                    <div class="emergency ">
                        <img src="../../assets/images/icons/hospital-phone.svg" alt="">
                        <span class="d-flex flex-column gap-0">
                            <h2 class="contact-sub-headers libra">Emergency</h2>
                            <p class="contact-information"
                                style="cursor: pointer; text-decoration: none;color: #0D6EFD;"
                                (click)="openDialPad(labData?.phoneCode, labData?.phone)"> {{ labData?.phoneCode }} {{
                                labData?.phone }} </p>
                        </span>
                    </div>
                    <div class="emergency ">
                        <img src="../../assets/images/icons/hospital-location.svg" alt="">
                        <span class="d-flex flex-column gap-0">
                            <h2 class="contact-sub-headers libra">Location</h2>
                            <p class="contact-information"> {{ labData?.address }} </p>
                        </span>
                    </div>
                    <div class="emergency ">
                        <img src="../../assets/images/icons/hospital-website.svg" alt="">
                        <span class="d-flex flex-column gap-0">
                            <h2 class="contact-sub-headers libra">Website</h2>
                            <p class="contact-information" style="cursor: pointer;text-decoration: none;color: #0D6EFD;"
                                (click)="openWebsite(labData?.url)"> {{ labData?.url }} </p>
                        </span>
                    </div>

                    <div class="r">
                        <div class="social-imgs gap-2">
                            <img (click)="socialNavigations('fb')" src="/assets/images/hospital-fb.svg" alt="fb">
                            <img (click)="socialNavigations('insta')"
                                src="../../assets/images/icons/hospital-instagram.svg" alt="insta">
                            <img (click)="socialNavigations('linkedin')"
                                src="../../assets/images/icons/hospital-linkedin.svg" alt="linkedin">
                            <img (click)="socialNavigations('x')" src="../../assets/images/icons/twitter-icon1.svg"
                                alt="x">
                        </div>
                        <div class="qrCode">
                            <img [src]="labData?.qrCodeURL" alt="qr" width="75px" height="75px">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="about-us-outer">
            <div class="About-us p-0 g-0 d-flex flex-column flex-lg-row">
                <div class="img col-12 col-lg-6 d-flex justify-content-center">
                    <img src="\assets\images\labs-aboutus-img.png" class="d-flex d-lg-none d-md-block img-fluid"
                        style="height: 438px !important; width:98% !important; border-radius: 20px;"
                        alt=" About-us Image">
                    <img src="\assets\images\labs-aboutus-img.png" class="d-none d-lg-block img-fluid h-auto"
                        style=" border-radius: 20px;" alt="About-us Image">
                </div>
                <div class="top-intro about-top-intro col-12 col-md-6 w-100 w-md-25 " style="flex: 1;">
                    <p class="welcomee libra mt-3  lh-sm">About Us</p>
                    <p *ngIf="!labData?.aboutId?.about" class="to-be-updated">To Be Updated Soon</p>
                    <p *ngIf="labData?.aboutId?.about && labData?.aboutId?.about" class="AboutUs-Description lh-sm"
                        [innerHTML]="labData?.aboutId?.about" style="text-align: justify;word-break: break-all;"></p>
                    <div class=" d-flex flex-wrap certificates-container">
                        <span *ngFor="let certificate of labData?.certifications" class="about-us-certificates">
                            <img src="../../../../assets/images/Product Details - Certificate Icon.svg" width="48px"
                                height="48px" alt="">
                            <div>{{certificate?.name}}</div>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="specialities d-flex align-items-center justify-content-center text-center">
            <div class="equipmentS specialities-data">
                <div class="">
                    <span class="contact-heading libra">Our Specialities</span>
                </div>
                <div class="sliderContainerSpecialities d-flex align-items-center" *ngIf=" specialitiesData.length > 0; else noData">
                    <img class="d-none d-lg-block custom-hide" src="assets/images/specialities_left-arrow.svg"
                        alt="Left Arrow" (click)="slide('left', 'specialityContainer')"
                        [class.disabled]="!canSlideLeftSpecialities" style="cursor: pointer;">

                    <div class="imgs-containerLab row-cols-2 row-lg d-flex d-lg-flex flex-lg-row overflow-hidden specialityContainer"
                        style=" flex-wrap: nowrap; scroll-behavior: smooth; white-space: nowrap;">
                        <div class="imgSpeciality speciality-items-lab" *ngFor="let speciality of specialitiesData">
                            <img [src]="speciality[1]" alt="equipments" width="60px" height="60px">
                            <p class="infraName">
                                <span *ngFor="let line of splitText(speciality[0])">
                                    {{ line }}<br>
                                </span>
                            </p>
                        </div>
                    </div>
                    <img class="d-none d-lg-block custom-hide" src="assets/images/specialities_right-arrow.svg"
                        alt="Right Arrow" (click)="slide('right', 'specialityContainer')"
                        [class.disabled]="!canSlideRightSpecialities" style="cursor: pointer;">
                </div>
                <ng-template #noData>
                    <p class="to-be-updated" style="margin-top: 20px;">To be Updated Soon</p>
                </ng-template>
            </div>
        </div>

        <div class="portfolio" >
            <div class="heading">
                <span class=" libra" style="color: #484848; line-height: 10px; font-size: 18px;">We Offer Our Best </span>
                <div class="contact-heading headline libra" >Lab Tests</div>
            </div>            
            <div class="serviceSliderContainer" *ngIf="testsData.length > 0; else noData">
                <img class="d-none d-sm-block d-lg-block left-arrow" src="assets/images/specialities_left-arrow.svg"
                    alt="Left Arrow" (click)="slide('left', 'bestServices-container')"
                    [class.disabled]="!canSlideLeftServices" style="cursor: pointer; width: 40px; height: auto;">            
                <div class="serviceImagesClinic bestServices-container">
                    <div class="staticImages " *ngFor="let tests of testsData">
                        <img [src]="tests[1]" alt="No Image" width="60px" height="60px">
                        <p class="infraName">{{ tests[0] }}</p>
                    </div>
                </div>            
                <img class="d-none d-sm-block d-lg-block right-arrow" src="assets/images/specialities_right-arrow.svg"
                    alt="Right Arrow" (click)="slide('right', 'bestServices-container')" 
                    [class.disabled]="!canSlideRightServices" style="cursor: pointer; width: 40px; height: auto;">     
            </div>  
            <ng-template #noData>
                <p class="to-be-updated">To be Updated Soon</p>
            </ng-template>          
        </div>

        <div class="equipments advanced-equipment" style="background-color: rgba(225, 241, 255, 1);">
            <div class="heading headline our-advanced p-0 p-md-4 text-center">
                <h2 class="mt-3 libra" style="color:#484848; padding-bottom:5px;">OUR ADVANCED</h2>
                <span class="contact-heading header libra" style="margin-top: 0px;">Medical Equipments</span>
            </div>
            <div class="sliderContainer" *ngIf="equipmentsData.length > 0; else noEquipments">
                <img class="d-none d-sm-block d-lg-block left-arrow" src="assets/images/specialities_left-arrow.svg"
                    alt="Left Arrow" (click)="slide('left', 'ourAdvanced-container')"
                    [class.disabled]="!canSlideLeftEquipments" style="cursor: pointer;">
                <div class="imgs-container content ourAdvanced-container"
                    [class.scroll]="equipmentsData.length > 5 || (isSmallScreen && equipmentsData.length > 0)"
                    style="padding-bottom: 1rem;">
                    <ng-container *ngFor="let equipment of equipmentsData let i=index">
                        <div class="imgsEquipments col-5 advanced-equipment-imgs">
                            <img [src]="equipment.imageUrl" alt="equipments"
                                class="d-block d-md-none img-fluid imgMobile"
                                style="object-fit: cover;  width: 100%; max-height: 250px;">
                            <img [src]="equipment.imageUrl" alt="equipments" class="d-none d-md-block " width="300px"
                                height="250px">
                            <p class="infraName">{{ equipment.name }}</p>
                        </div>
                    </ng-container>
                </div>
                <img *ngIf="equipmentsData.length >= 5" class="d-none d-sm-block d-lg-block"
                    src="assets/images/specialities_right-arrow.svg" alt="Right Arrow"
                    (click)="slide('right', 'ourAdvanced-container')" [class.disabled]="!canSlideRightEquipments"
                    style="cursor: pointer;">
            </div>
            <ng-template #noEquipments>
                <p class="to-be-updated">To be Updated Soon</p>
            </ng-template>
        </div>
 

        <div class="doctors-container advanced-equipment infrastructure-div"
            style="background-color:white">
            <div class="heading team-meet">
                <h2 class="libra" style="color: #484848;">MEET OUR TEAM OF</h2>
                <span class="contact-heading headline header libra mb-3">Healthcare Experts</span>
            </div>
            <div class="arrow-lab-container" *ngIf="labData?.members?.length > 0; else noDoctors ">
                <img [ngClass]="{'disabled-doctor': !canSlideLeftDoctors}" class="d-none d-lg-block "
                    src="assets/images/specialities_left-arrow.svg" alt="Left Arrow"
                    (click)="slide('left','imgs-doctor-container')" style="cursor: pointer;">
                <div class="cards  d-flex gap-4  ">
                    <div class="imgs-doctor-container" [ngClass]="containerClass">
                        <div class="card expert-card " *ngFor="let doctor of labData?.members">

                            <div class="image-wrapper">
                                <img *ngIf="doctor.image; else noImage" class="card-img-top" [src]="doctor.image"
                                    alt="profile pic">
                                <ng-template #noImage>
                                    <div class="fallback-img"> {{ getInitial(doctor?.name) }}</div>
                                </ng-template>
                            </div>

                            <div class=" info">
                                <span class="name">
                                    <span class="dr"></span>
                                    <span class="n">{{ doctor?.name }}</span>
                                </span>
                                <p class="designation" style="white-space: normal; text-align: center; ">
                                    {{ doctor.position?.name }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <img [ngClass]="{'disabled-doctor': !canSlideRightDoctors}" class="d-none d-lg-block "
                    src="assets/images/specialities_right-arrow.svg" alt="Right Arrow"
                    (click)="slide('right','imgs-doctor-container')" style="cursor: pointer;">
            </div>
            <ng-template #noDoctors>
                <p class="to-be-updated">To be Updated soon</p>
            </ng-template>
        </div>

        <div class="achievements " style="width: 100%; background-color: rgba(225, 241, 255, 1);">
            <div class="heading p-0 p-md-4">
                <h2 class="libra achievments-title">ACHIEVEMENTS & CONTRIBUTIONS</h2>
                <span class="contact-heading libra text-sm-center text-md-auto "
                    style="margin-top: 0px; padding-bottom: 5px;text-align: center;">Recognized Excellence in
                    Healthcare</span>
                <p class="mt-2 mb-3 libra text-center">Honoring milestones, published works, and community efforts that
                    define our commitment to healthcare excellence.</p>
            </div>
            <div class="lab-acheivements" >
                <img class="d-none d-sm-block d-lg-block left-arrow" src="assets/images/specialities_left-arrow.svg"
                    alt="Left Arrow" (click)="slide('left','labCards-content-container')" [class.disabled]="!canSlideLeftAcheivements"
                    style="cursor: pointer; width: 40px; height: auto;">
                <div class="t t1 col-12 d-flex align-items-center flex-column d-md-flex flex-md-row align-items-md-start" class="labCards-content-container">
                    <div class="lab-acheivements-contributions">
                        <h2 class="lab-acheivement-card-title">Publications</h2>
                        <div class="publications-scroll-container">
                            <ng-container *ngIf="publications && publications?.length !== 0; else elseBlock">
                                <span class="publications-inner" *ngFor="let publication of publications">
                                    <div class="lab-content-container">
                                        <p class="data-title">{{publication.title}}</p>
                                        <p class="lab-acheivement-label">Published by : <span class="lab-acheivement-value">{{publication.publishedby}}</span></p>
                                    </div>
                                </span>  
                            </ng-container>
                            <ng-template #elseBlock>
                                <p class="to-be-updated" style ="margin: 35% 20px !important; text-align: center;">To Be Updated Soon</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="lab-acheivements-contributions">
                        <h2 class="lab-acheivement-card-title">Awards & Honors</h2>
                        <div class="publications-scroll-container">
                            <ng-container *ngIf="awards && awards?.length !== 0; else elseBlock">
                                <span class="publications-inner" *ngFor="let award of awards">
                                    <div class="lab-content-container">
                                        <p class="data-title">{{award.title}}</p>
                                        <p class="lab-acheivement-label">Awarded by: <span class="lab-acheivement-value">{{award.association}}</span></p>
                                    </div>
                                </span>
                            </ng-container>
                            <ng-template #elseBlock>
                                <p class="to-be-updated" style ="margin: 35% 20px !important; text-align: center;">To Be Updated Soon</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="lab-acheivements-contributions">
                        <h2 class="lab-acheivement-card-title">Associations & Organizations</h2>
                        <div class="publications-scroll-container">
                            <ng-container *ngIf="associations && associations?.length !== 0; else elseBlock">
                                <span class="publications-inner" *ngFor="let association of associations">
                                    <div class="lab-content-container">
                                        <p class="data-title"> {{association.associationName}} </p>
                                        <p class="lab-acheivement-label">Position: <span class="lab-acheivement-value">{{ association.positionHeld }}</span></p>
                                        <p class="lab-acheivement-label">From: <span class="lab-acheivement-value">{{ association.fromDate | date:'MM/dd/yyyy' }} to {{
                                            association.toDate | date:'MM/dd/yyyy' }}</span></p>
                                    </div>
                                </span>
                            </ng-container>
                            <ng-template #elseBlock>
                                <p class="to-be-updated" style ="margin: 35% 20px !important; text-align: center;">To Be Updated Soon</p>
                            </ng-template>
                        </div>
                    </div>
                    <div class="lab-acheivements-contributions">
                        <h2 class="lab-acheivement-card-title">Volunteering & Causes</h2>
                        <div class="publications-scroll-container">
                            <ng-container *ngIf="volunteerings && volunteerings?.length !== 0; else elseBlock">
                                <span class="publications-inner" *ngFor="let volunteering of volunteerings">
                                    <div class="lab-content-container">
                                        <p class="data-title"> {{volunteering.organizationName}} </p>
                                        <p class="lab-acheivement-label">Position: <span class="lab-acheivement-value">{{ volunteering.positionHeld }}</span></p>
                                        <p class="lab-acheivement-label">From: <span class="lab-acheivement-value">{{ volunteering.fromDate | date:'MM/dd/yyyy' }} to {{
                                            volunteering.toDate | date:'MM/dd/yyyy' }}</span></p>
                                    </div> 
                                </span>
                            </ng-container>
                            <ng-template #elseBlock>
                                <p class="to-be-updated" style ="margin: 35% 20px !important; text-align: center;">To Be Updated Soon</p>
                            </ng-template>
                        </div>
                    </div>                    
                </div>
                <img class="d-none d-sm-block d-lg-block" src="assets/images/specialities_right-arrow.svg" alt="Right Arrow"
                    (click)="slide('right','labCards-content-container')" [class.disabled]="!canSlideRightAcheivements"
                    style="cursor: pointer; width: 40px; height: auto;">  
            </div>
        </div>
        <div class="lookat">
            <div class="outer-lookat">
                <div class="inner-lookat">
                    <span class="lookat-heading libra">HAVE A LOOK AT</span>
                    <span class="lookat-subtitle libra">Our Facilities & Latest Activities </span>
                </div>
            </div>
            <div class="l">
                <div class="inner-l">
                    <div class="small col-5 col-lg-auto m-1 " *ngFor="let photo of labData?.photos"
                        style="max-width:260px;">
                        <img *ngIf="photo?.photoLink" [src]="photo?.photoLink" alt="small0"
                            class="img-fluid d-block d-sm-none d-md-none" style="width:-webkit-fill-available;">
                        <img *ngIf="photo?.photoLink" [src]="photo?.photoLink" alt="small0"
                            class="d-none d-sm-block d-md-none col-12" height="280px">
                        <img *ngIf="photo?.photoLink" [src]="photo?.photoLink" alt="small0"
                            class="d-none d-sm-none d-md-block col-12" height="280px">
                    </div>
                </div>
                <img src="../../assets/images/hospital-lookatr.svg" alt="r" class="d-none d-xl-block" width="320px"
                    height="100%">
            </div>
        </div>
    </div>

    <app-website-footer></app-website-footer>
</div>